export const messages = {
  en: {
    productSeckillOrder: {
      title: 'Seckill Orders',
      queryCondition: 'Query Conditions',
      query: 'Query',
      orderId: 'Order ID',
      orderIdPlaceholder: 'Please enter order ID',
      productName: 'Product Name',
      productNamePlaceholder: 'Please enter product name',
      buyer: 'Buyer',
      buyerPlaceholder: 'Please enter buyer name',
      productImage: 'Product Image',
      quantity: 'Quantity',
      seckillPrice: 'Seckill Price',
      purchaseTime: 'Purchase Time',
      status: 'Status',
      completed: 'Completed',
      pending: 'Pending Payment',
      deadline: 'Deadline'
    }
  },
  zh: {
    productSeckillOrder: {
      title: '秒杀订单',
      queryCondition: '查询条件',
      query: '查询',
      orderId: '订单ID',
      orderIdPlaceholder: '请填写订单',
      productName: '商品名称',
      productNamePlaceholder: '请填写产品名称',
      buyer: '购买者',
      buyerPlaceholder: '请填写购买者',
      productImage: '商品图片',
      quantity: '购买数量',
      seckillPrice: '秒杀金额',
      purchaseTime: '购买时间',
      status: '状态',
      completed: '完成',
      pending: '待支付',
      deadline: '截止时间'
    }
  }
}